var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PaymentBox',[_c('BoxContent',{attrs:{"title":'Pagamento realizado com Sucesso',"icon":'PixIcon',"animated":true,"success":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }